import { formatString, formatTimestampFull } from "@@common";
import { formatDate } from "../../../common/formatDate";
import { PropertyDisplayFormat } from "../../Models/PropertyDisplayFormat";
import { TableColumnModel } from "../../Models/TableModel";

export const formatColumnValue = (value: any, column: TableColumnModel): string => {
  if (value == null) return "";

  if (column.ValueTemplate) {
    return formatString(column.ValueTemplate, value);
  }

  switch (column.Format) {
    case PropertyDisplayFormat.Date:
      return formatDate(value);
    case PropertyDisplayFormat.DateTime:
      return formatTimestampFull(value);
    default:
      return value;
  }
};
